/** Logs applicatifs : uniquement en développement (en prod, silenceConsoleInProd coupe aussi console.* tiers). */
export function devLog(...args) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}

export function devWarn(...args) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
}

/** Erreurs applicatives : visibles uniquement en développement (inspecteur propre en prod). */
export function devError(...args) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}
